const e = {
  postV1OwnertypeOwneridLaunchDeposit: {
    schema: {
      method: "post",
      url: "/v1/{ownerType}/{ownerId}/launch/deposit",
      mediaType: "application/json"
    }
  },
  postV1OwnertypeOwneridLaunch: {
    schema: {
      method: "post",
      url: "/v1/{ownerType}/{ownerId}/launch",
      mediaType: "application/json"
    }
  },
  postV1OwnertypeOwneridLaunchWithdraw: {
    schema: {
      method: "post",
      url: "/v1/{ownerType}/{ownerId}/launch/withdraw",
      mediaType: "application/json"
    }
  }
};
export {
  e as v1Service
};
